import { Component, OnInit, ViewChild } from '@angular/core';
import { DisplayModes } from '../../models/enums';
import { AppConfigService } from '../../app.config';
import { GiveawayItemTypeService } from '../services/giveaway-item-type.service';
import { GiveawayItem } from '../models/giveaway-item.model';
import { Router } from '@angular/router';
import { AlertService, DialogType, MessageSeverity } from '../../services/alert.service';
import { AppTranslationService } from '../../services/app-translation.service';
import { ModalDirective } from 'ngx-bootstrap';


@Component({
  selector: 'crm-giveaway-item-type',
  templateUrl: './giveaway-item-type.component.html',
  styleUrls: ['./giveaway-item-type.component.css']
})
export class GiveawayItemTypeComponent implements OnInit {
  giveawayItems: GiveawayItem[];
  displayMode: DisplayModes;
  pageSize: number;
  public logo = require("../../../app/assets/images/demo/Icon_Giveaway Items.png");

  selectedGiveawayItemsId;
  addNew: boolean = false;
  @ViewChild('deleteModal')
  deleteModal: ModalDirective;

  constructor(private readonly giveawayItemTypeService: GiveawayItemTypeService,
    private readonly router: Router,
    private readonly alertService: AlertService,
    private readonly appConfig: AppConfigService,
    private readonly translateService: AppTranslationService) {
    this.pageSize = this.appConfig.settings.pageSize;
    this.displayMode = DisplayModes.Success;
  }

  ngOnInit() {
    this.getAll();
  }


  getAll() {
    this.displayMode = DisplayModes.Loading;
    this.giveawayItemTypeService.getAll().subscribe(response => {
      this.giveawayItems = response;
      this.displayMode = DisplayModes.Success;
    }, error => {
      this.displayMode = DisplayModes.Error;
    });
  }
  gotoNew() {
    this.addNew = true;
  }

  gotoEdit(itemId) {
    this.selectedGiveawayItemsId = itemId;
    this.addNew = true;
  }

  confirmDeleteItem(item) {
    this.selectedGiveawayItemsId = item;
    this.deleteModal.show();

  }

  delete() {
    this.hideDeleteModal();
    this.displayMode = DisplayModes.Loading;
    this.alertService.startLoadingMessage(`Giveaway item delete`, `deleting giveaway item type, ${this.selectedGiveawayItemsId.name}! ....`);

    this.giveawayItemTypeService.delete(this.selectedGiveawayItemsId.id).subscribe(response => {
      this.displayMode = DisplayModes.Success;
      this.alertService.stopLoadingMessage();

      this.alertService.showMessage("Giveaway item type delete", `${this.selectedGiveawayItemsId.name} deleted successfully!`, MessageSeverity.Success);
      this.getAll();
    }, err => {
      this.displayMode = DisplayModes.Success;
      this.alertService.stopLoadingMessage();

      this.alertService.showMessage(`Giveaway item delete`, `delete giveaway item type, ${this.selectedGiveawayItemsId.name} failed please try again later!`, MessageSeverity.Error);

    });
  }

  closeAdding(event) {
    this.selectedGiveawayItemsId = undefined;
    this.addNew = false;
    if (event) {
      this.getAll();
    }
  }

  hideDeleteModal() {
    this.deleteModal.hide();
  }

}
